import NutritionFacts from './NutritionFacts';

export default NutritionFacts;
